<template>
<div v-if="organisation">
    <v-toolbar flat color="white">
        <v-avatar>
            <v-img :src="organisation.logo" contain></v-img>
        </v-avatar>
        <v-toolbar-title>
            {{organisation.name}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-card flat>
            <v-layout wrap>
                <v-flex xs12>
                    <v-icon small class="mx-1">device_hub</v-icon>
                    <span>{{organisation.locationNetworks}}</span>
                </v-flex>
                <v-flex xs12>
                    <h4>Networks</h4>
                </v-flex>

            </v-layout>
        </v-card>
        <v-card flat>
            <v-layout wrap>
                <v-flex xs12>
                    <v-icon small class="mx-1">miscellaneous_services</v-icon>
                    <span>{{organisation.activeServiceAccounts}}</span>
                </v-flex>
                <v-flex xs12>
                    <h4>Service Accounts</h4>
                </v-flex>

            </v-layout>
        </v-card>
        <v-card flat>
            <v-layout wrap>
                <v-flex xs12>
                    <v-icon small class="mx-1">bolt</v-icon>
                    <span>{{organisation.locationsPassed}}</span>
                </v-flex>
                <v-flex xs12>
                    <h4>Connected</h4>
                </v-flex>

            </v-layout>
        </v-card>
        <v-card flat>
            <v-layout wrap>
                <v-flex xs12>
                    <v-icon small class="mx-1">location_on</v-icon>
                    <span>{{organisation.locations}}</span>
                </v-flex>
                <v-flex xs12>
                    <h4>Locations</h4>
                </v-flex>

            </v-layout>
        </v-card>

    </v-toolbar>
    <!-- <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab>Overview</v-tab>
        <v-tab>Subscriptions</v-tab>
    </v-tabs> -->
    <div v-if="tab==0">
        <v-layout justify-start wrap>
            <v-flex xs6>
                <v-list :key="agreementKey">
                    <v-subheader style="background: #f0f0f0">Organisation Info</v-subheader>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title style='font-size: 14px'>
                                Xero Account
                            </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action style="width: 300px;font-size: 14px">
                            <v-autocomplete style='font-size: 14px' v-model="organisation.xeroContactId" ref="accountingId" color="black" clearable v-on:blur="$refs['accountingId'].blur(), updateOrganisation({id: organisation.id, xeroContactId: organisation.xeroContactId})" placeholder="Search contacts" :items="xeroContacts" item-text="name" item-value="id"></v-autocomplete>
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-subheader style="background: #f0f0f0">Digital Documents <v-spacer></v-spacer>
                        <v-btn icon small @click="addDocument()">
                            <v-icon small>add</v-icon>
                        </v-btn>
                    </v-subheader>
                    <v-list-tile v-for="document in organisationAgreements" :key="document.id" @click="downloadContent(document)">
                        <v-list-tile-content>
                            <v-list-tile-title style="font-size: 14px">
                                {{document.name}}
                            </v-list-tile-title>
                            <v-list-tile-sub-title style='font-size: 14px'>
                                {{document.assignedTo.name}} {{document.assignedTo.surname}} <span v-if="!document.acceptedDate"> | Due {{document.date}}</span>
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-icon v-if="!document.accepted" color="orange">warning</v-icon>
                            <v-icon v-else color="green">check_circle_outline</v-icon>
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-list-tile v-if="organisationAgreements.length==0">
                        <v-list-tile-sub-title style='font-size: 14px'>
                            No digital documents
                        </v-list-tile-sub-title>
                    </v-list-tile>
                </v-list>
            </v-flex>
            <v-flex xs6>
                <v-list>
                    <v-subheader style="background: #f0f0f0">Subscriptions <v-spacer></v-spacer>
                        <v-btn icon small @click="addSubscription()">
                            <v-icon small>add</v-icon>
                        </v-btn>
                    </v-subheader>
                    <v-list-tile v-for="subscription in subscriptions" :key="subscription.id">
                        <v-list-tile-action>
                            <v-layout justify-center>
                                <v-btn icon small @click="editSubscription(subscription)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                                <v-btn icon small @click="deleteSubscription(subscription)">
                                    <v-icon small color="red">delete</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title style="font-size: 14px">
                                {{subscription.name}}
                            </v-list-tile-title>
                            <v-list-tile-sub-title style="font-size: 14px">
                                {{subscription.gluePlan.type}}
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action style="font-size: 12px">
                            {{subscription.gluePlan.pricePerUnit | currency}} per unit
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-subheader style="background: #f0f0f0">Indicative Billing
                        <v-spacer></v-spacer>
                        <span v-if="indicativeBilling&&indicativeBilling.period">{{CalculateIndicativeBilling(subscriptions) | currency}}</span>
                    </v-subheader>
                    <v-list-tile v-for="subscription in subscriptions" :key="subscription.id">
                        <v-list-tile-action style="width: 150px">
                            <v-chip v-if="indicativeBilling.gluePercentage&&subscription.gluePlan.type =='Active Service Accounts'">
                                {{indicativeBilling.gluePercentage.toFixed(2)}}
                            </v-chip>
                            <v-chip v-else-if="subscription.gluePlan.type =='Installed Locations'">
                                {{indicativeBilling.unitsConnected}}
                            </v-chip>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title style="font-size: 14px">
                                {{subscription.name}}
                            </v-list-tile-title>
                            <v-list-tile-sub-title style="font-size: 14px">
                                {{subscription.gluePlan.type}}
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action style="font-size: 12px">
                            <span v-if="indicativeBilling.gluePercentage&&subscription.gluePlan.type =='Active Service Accounts'">
                                {{subscription.gluePlan.pricePerUnit*indicativeBilling.gluePercentage.toFixed(2) | currency}}
                            </span>
                            <span v-else-if="subscription.gluePlan.type =='Installed Locations'">
                                {{subscription.gluePlan.pricePerUnit*indicativeBilling.unitsConnected | currency}}
                            </span>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>
            </v-flex>

            <v-flex xs12>
                <v-list>
                    <v-subheader style="background: #f0f0f0">Billing runs</v-subheader>
                    <v-data-table :headers="headers" class="elevation-1" :items="billingSummary" :rows-per-page-items="[12, 25]" item-key="id" align-center disable-initial-sort style="cursor: pointer">
                        <template v-slot:items="props">
                            <td class="text-xs-left">{{props.item.periodStart}} to {{props.item.periodEnd}}</td>
                            <td class="text-xs-center">
                                <v-chip v-if="props.item.status=='Pending'" style="color: orange" outline>{{props.item.status}}</v-chip>
                                <v-chip v-else-if="props.item.status=='Approved'" color="success" outline>{{props.item.status}}</v-chip>
                            </td>
                            <td class="text-xs-center">{{props.item.unitsPassed}}<br><span style="height:20px; fontSize: 12px; color: green" v-if="props.index!=billingSummary.length-1&&CalculateUnitsPassed(props.item,billingSummary[props.index+1])>0">{{'+'+ CalculateUnitsPassed(props.item,billingSummary[props.index+1])+'%'}}</span><span style="height:20px; fontSize: 12px; color: red" v-else-if="props.index!=billingSummary.length-1&&CalculateUnitsPassed(props.item,billingSummary[props.index+1])<0">{{CalculateUnitsPassed(props.item,billingSummary[props.index+1])+'%'}}</span></td>
                            <td class="text-xs-center">{{props.item.unitsConnected}}<br><span style="height:20px; fontSize: 12px; color: green" v-if="props.index!=billingSummary.length-1&&CalculateUnitsConnected(props.item,billingSummary[props.index+1])>0">{{'+'+ CalculateUnitsConnected(props.item,billingSummary[props.index+1])+'%'}}</span><span style="height:20px; fontSize: 12px; color: red" v-else-if="props.index!=billingSummary.length-1&&CalculateUnitsConnected(props.item,billingSummary[props.index+1])<0">{{CalculateRevenueGrowth(props.item,billingSummary[props.index+1])+'%'}}</span></td>
                            <td class="text-xs-center">{{props.item.unitsLive}}<br><span style="height:20px; fontSize: 12px; color: green" v-if="props.index!=billingSummary.length-1&&CalculateUnitsLive(props.item,billingSummary[props.index+1])>0">{{'+'+ CalculateUnitsLive(props.item,billingSummary[props.index+1])+'%'}}</span><span style="height:20px; fontSize: 12px; color: red" v-else-if="props.index!=billingSummary.length-1&&CalculateUnitsLive(props.item,billingSummary[props.index+1])<0">{{CalculateRevenueGrowth(props.item,billingSummary[props.index+1])+'%'}}</span></td>
                            <td class="text-xs-center" style="fontSize: 14px">{{props.item.averageReturnPerUnit|currency}}<br><span style="height:20px; fontSize: 12px; color: green" v-if="props.index!=billingSummary.length-1&&CalculateARPU(props.item,billingSummary[props.index+1])>0">{{'+'+ CalculateARPU(props.item,billingSummary[props.index+1])+'%'}}</span><span style="height:20px; fontSize: 12px; color: red" v-else-if="props.index!=billingSummary.length-1&&CalculateARPU(props.item,billingSummary[props.index+1])<0">{{CalculateARPU(props.item,billingSummary[props.index+1])+'%'}}</span></td>
                            <td class="text-xs-center" style="padding: 10px">{{props.item.totalRevenue|currency}}<br><span outline style="height:20px; fontSize: 12px; color: green" v-if="props.index!=billingSummary.length-1&&CalculateRevenueGrowth(props.item,billingSummary[props.index+1])>0">{{'+'+ CalculateRevenueGrowth(props.item,billingSummary[props.index+1])+'%'}}</span><span style="height:20px; fontSize: 12px; color: red" v-else-if="props.index!=billingSummary.length-1&&CalculateRevenueGrowth(props.item,billingSummary[props.index+1])<0">{{CalculateRevenueGrowth(props.item,billingSummary[props.index+1])+'%'}}</span></td>
                            <td class="text-xs-center">{{props.item.totalRecurring|currency}} <br> <span style="height:20px; fontSize: 12px; color: green" v-if="props.index!=billingSummary.length-1&&CalculateRevenueGrowth(props.item,billingSummary[props.index+1])>0">{{'+'+ CalculateRecurringGrowth(props.item,billingSummary[props.index+1])+'%'}}</span><span style="height:20px; fontSize: 12px; color: red" v-else-if="props.index!=billingSummary.length-1&&CalculateRecurringGrowth(props.item,billingSummary[props.index+1])<0">{{CalculateRecurringGrowth(props.item,billingSummary[props.index+1])+'%'}}</span></td>
                            <td class="text-xs-center">{{props.item.totalOnceOff|currency}}<br><span style="height:20px; fontSize: 12px; color: green" v-if="props.index!=billingSummary.length-1&&CalculateOnceOffGrowth(props.item,billingSummary[props.index+1])>0">{{'+'+ CalculateOnceOffGrowth(props.item,billingSummary[props.index+1])+'%'}}</span><span style="height:20px; fontSize: 12px; color: red" v-else-if="(props.index!=billingSummary.length-1)&&CalculateOnceOffGrowth(props.item,billingSummary[props.index+1])<0">{{CalculateOnceOffGrowth(props.item,billingSummary[props.index+1])+'%'}}</span></td>
                        </template>
                        <template v-slot:pageText="props">Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
                    </v-data-table>
                </v-list>
            </v-flex>
            <v-flex xs12>
                <v-list>
                    <v-subheader style="background: #f0f0f0">Invoices</v-subheader>
                    <v-data-table :headers="invoiceHeaders" :items="xeroInvoices" :pagination.sync="pagination">
                        <template v-slot:items="props">
                            <td class="text-xs-center">{{props.item.invoiceNumber}}</td>
                            <td class="text-xs-center">{{formatDate(props.item.dueDate)}}</td>

                            <td class="text-xs-center">

                                <v-chip small style="height: 18px; font-size: 12px" class="white--text" :color="getStatusColor(props.item.status)">{{props.item.status}}</v-chip>
                            </td>
                            <td class="text-xs-center">{{props.item.subtotal | currency}}</td>
                            <td class="text-xs-center">{{props.item.totalTax | currency}}</td>
                            <td class="text-xs-center">{{props.item.total | currency}}</td>
                            <td class="text-xs-center">{{props.item.amountPaid | currency}}</td>
                        </template>
                    </v-data-table>
                </v-list>
            </v-flex>
        </v-layout>
    </div>
    <v-dialog v-model="subscriptionModal" persistent width="750px">
        <v-card v-if="item&&item.modalType">
            <v-toolbar flat color='white'>
                <v-toolbar-title>
                    {{item.modalType}} Subscription
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="!item.id" :disabled="!item.gluePlanId||!item.name" outline color="black" @click="createSubscription()">Save</v-btn>
                <v-btn v-else outline color="black" @click="updateSubscription()">Save</v-btn>

                <v-btn flat @click="subscriptionModal=false, item={}">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center wrap>
                    <v-flex xs10 mx-1>
                        <v-text-field label="Invoice Description" v-model="item.name" box style="font-size: 14px"></v-text-field>
                    </v-flex>
                    <v-flex xs10 mx-1>
                        <v-select dense label="Selected Plan" v-model="item.gluePlanId" :items="plans" item-text="name" item-value="id" box style="font-size: 14px"></v-select>
                    </v-flex>

                </v-layout>

            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="documentModal" persistent width="750px">
        <v-card v-if="item">
            <v-toolbar flat color='white'>
                <v-toolbar-title>
                    Digital Document
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="documentModal=false, item={},page=0">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center wrap v-if="page==0">
                    <v-flex xs5 mx-1>
                        <v-text-field label="Document Title" v-model="item.name" box></v-text-field>
                    </v-flex>
                    <v-flex xs5 mx-1>
                        <v-autocomplete ref="orgAgreement" color="black" clearable @change="updateVariables()" v-on:blur="$refs['orgAgreement'].blur()" v-model="item.agreement" return-object :items="allAgreements" box label="Attached Agreement" item-text="name" item-value="id"></v-autocomplete>
                    </v-flex>
                    <v-flex xs5 mx-1>
                        <v-menu v-model="item.menu" :close-on-content-click="true" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-list-tile v-on="on">
                                    <v-list-tile-action>
                                        <v-icon>event</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title :key="item.key" style="font-size: 14px">
                                            {{formatDate(item.date)}}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 14px; color: grey">
                                            Agreement Due Date
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <!-- <span :style="{'font-size': '12px', cursor: 'pointer', 'font-weight': 'bold'}"> </span> -->
                            </template>
                            <v-date-picker v-model="item.date" @change="item.key++" no-title scrollable>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs5 mx-1>
                        <v-autocomplete ref="contact" color="black" clearable v-on:blur="$refs['contact'].blur()" v-model="item.contactId" :items="contacts" box label="Assigned Contact" item-text="fullname" item-value="id"></v-autocomplete>
                    </v-flex>

                </v-layout>
                <v-layout justify-center wrap v-if="page==1&&item.variables && item.variables.length>0" :key="variableKey">
                    <v-flex xs12 class="text-xs-center">
                        <h4>Document Variables</h4>
                    </v-flex>
                    <v-flex xs4 class="px-2" v-for="(variable, i) in item.variables" :key="i">
                        <v-text-field :label="variable.key" v-model="variable.value" box style="font-size: 12px"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout justify-center v-if="page==2">
                    <v-flex xs12 px-2>
                        <vue-markdown :source="formattedContent" class="text-xs-left" style="width: 100%;overflow-y: auto; max-height: 40vh"></vue-markdown>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-btn v-if="page>=1" @click="page--" color="primary" class="white--text" round>
                        <v-icon class="ml-1">chevron_left</v-icon> Back
                    </v-btn>

                    <v-spacer></v-spacer>
                    <v-btn @click="page++" v-if="page<2" color="primary" class="white--text" round>Next <v-icon class="ml-1">chevron_right</v-icon>
                    </v-btn>
                    <v-btn v-else color="primary" class="white--text" round @click="submitAgreement()">Submit
                    </v-btn>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import Api from "../services/Api";
import dateformat from "dateformat";
import VueMarkdown from 'vue-markdown'
export default {
    components: {
        VueMarkdown
    },
    data: () => ({
        organisationAgreements: [],
        allAgreements: [],
        agreementKey: 0,
        contacts: [],
        documentModal: false,
        subscriptionModal: false,
        billingSummary: [],
        page: 0,
        headers: [{
                text: "Billing Period",
                // align: "start",
                value: "periodEnd"
            },
            {
                text: "Status",
                align: "center",
                value: "status"
            },
            {
                text: "Units Passed",
                align: "center",
                value: "unitsPassed"
            },
            {
                text: "Units Connected",
                align: "center",
                value: "unitsConnected"
            },

            {
                text: "Live Connections",
                align: "center",
                value: "unitsLive"
            },
            {
                text: "ARPU",
                align: "center",
                value: "averageReturnPerUnit"
            },
            {
                text: "Total Sales",
                align: "center",
                value: "totalRevenue"
            },
            {
                text: "Recurring Sales",
                align: "center",
                value: "totalRecurring"
            },
            {
                text: "Once-off Sales",
                align: "center",
                value: "totalOnceOff"
            }
        ],
        invoiceHeaders: [{
                text: "Invoice",
                align: "center",
                value: "invoiceNumber",

            },
            {
                text: "Due",
                align: "center",
                value: "dueDate",

            },
            {
                text: "Status",
                align: "center",
                value: "status",
            },
            {
                text: "Subtotal",
                align: "center",
                value: "subtotal",
            },
            {
                text: "Total Tax",
                align: "center",
                value: "totalTax",
            },
            {
                text: "Total",
                align: "center",
                value: "total",
            },
            {
                text: "Amount Paid",
                align: "center",
                value: 'amountPaid'
            },
        ],
        indicativeBilling: {},
        item: {},
        organisation: {},
        pagination: {
            sortBy: 'dueDate',
            descending: true,
            rowsPerPage: 10
        },
        subscriptions: [],
        tab: 0,
        xeroContacts: [],
        xeroInvoices: [],
        xeroUrl: null,
        variableKey: 0
    }),
    computed: {
        formattedContent() {
            let content = ''
            if (this.item.agreement) {
                content = this.item.agreement.content
                if (this.item.variables) {
                    for (let i = 0; i < this.item.variables.length; i++) {
                        var re = new RegExp(this.item.variables[i].key, 'g')
                        content = content.replace(re, this.item.variables[i].value)
                        content = content.replace('{{', '').replace('}}','')
                    }
                }
            }
            return content
        }
    },
    created() {
        this.fetchOrganisation()
        this.initialize()
        this.getGluePlans()
    },
    methods: {
        addDocument() {
            let date = new Date()
            date.setDate(date.getDate() + 7)
            this.item = {
                date: this.formatDate(date),
                menu: false,
                key: 0
            }
            this.documentModal = true
        },
        addSubscription() {
            this.item = {
                modalType: 'Add',
                organisationId: this.organisation.id
            }
            this.subscriptionModal = true
        },
        editSubscription(item) {
            this.item = item
            this.item.modalType = 'Edit'
            this.subscriptionModal = true
        },
        CalculateRevenueGrowth(currentMonth, lastMonth) {
            return Math.round(((currentMonth.totalRevenue - lastMonth.totalRevenue) / lastMonth.totalRevenue) * 10000) / 100
        },
        CalculateRevenueGrowthPeriod(period) {
            let start = this.billingSummary[0]
            let end = this.billingSummary[period - 1]
            if (end) {
                return Math.round(((start.totalRevenue - end.totalRevenue) / end.totalRevenue) * 10000) / 100

            } else {
                return undefined
            }
        },

        CalculateRevenueGrowthCount(period) {
            let start = this.billingSummary[0]
            let end = this.billingSummary[period - 1]
            if (end) {
                return start.totalRevenue - end.totalRevenue
            } else {
                return undefined
            }
        },

        CalculateARPUPeriod(period) {
            let start = this.billingSummary[0]
            let end = this.billingSummary[period - 1]
            if (end) {
                return Math.round(((start.averageReturnPerUnit - end.averageReturnPerUnit) / end.averageReturnPerUnit) * 10000) / 100

            } else {
                return undefined
            }
        },
        CalculateARPUCount(period) {
            let start = this.billingSummary[0]
            let end = this.billingSummary[period - 1]
            if (end) {
                return start.averageReturnPerUnit - end.averageReturnPerUnit
            } else {
                return undefined
            }
        },
        CalculateLiveConnectionsPeriod(period) {
            let start = this.billingSummary[0]
            let end = this.billingSummary[period - 1]
            if (end) {
                return Math.round(((start.unitsLive - end.unitsLive) / end.unitsLive) * 10000) / 100

            } else {
                return undefined
            }
        },
        CalculateLiveConnectionsCount(period) {
            let start = this.billingSummary[0]
            let end = this.billingSummary[period - 1]
            if (end) {
                return start.unitsLive - end.unitsLive

            } else {
                return undefined
            }
        },
        CalculateRecurringGrowth(currentMonth, lastMonth) {
            return Math.round(((currentMonth.totalRecurring - lastMonth.totalRecurring) / lastMonth.totalRecurring) * 10000) / 100
        },
        CalculateOnceOffGrowth(currentMonth, lastMonth) {
            return Math.round(((currentMonth.totalOnceOff - lastMonth.totalOnceOff) / lastMonth.totalOnceOff) * 10000) / 100
        },
        CalculateUnitsPassed(currentMonth, lastMonth) {
            return Math.round(((currentMonth.unitsPassed - lastMonth.unitsPassed) / lastMonth.unitsPassed) * 10000) / 100
        },
        CalculateUnitsConnected(currentMonth, lastMonth) {
            return Math.round(((currentMonth.unitsConnected - lastMonth.unitsConnected) / lastMonth.unitsConnected) * 10000) / 100
        },
        CalculateUnitsLive(currentMonth, lastMonth) {
            return Math.round(((currentMonth.unitsLive - lastMonth.unitsLive) / lastMonth.unitsLive) * 10000) / 100
        },
        CalculateARPU(currentMonth, lastMonth) {
            return Math.round(((currentMonth.averageReturnPerUnit - lastMonth.averageReturnPerUnit) / lastMonth.averageReturnPerUnit) * 10000) / 100
        },
        CalculateIndicativeBilling(subscriptions) {
            let result = 0
            for (let i = 0; i < subscriptions.length; i++) {
                if (subscriptions[i].gluePlan.type == 'Active Service Accounts') {
                    result += subscriptions[i].gluePlan.pricePerUnit * this.indicativeBilling.gluePercentage.toFixed(2)
                } else if (subscriptions[i].gluePlan.type == 'Installed Locations') {
                    result += subscriptions[i].gluePlan.pricePerUnit * this.indicativeBilling.unitsConnected
                }
            }
            return result
        },
        fetchOrganisation() {
            Api().get('/admin/billableOrganisations/' + this.$route.params.organisationId).then(res => {
                this.organisation = res.data
                if (this.organisation.xeroContactId) {
                    this.getXeroInvoices(this.organisation.xeroContactId)
                }
                this.fetchBillingSummaries(this.organisation.id)
                this.getOrganisationSubscriptions(this.organisation.id)
                this.getOrganisationAgreements(this.organisation.id)
                this.getOrganisationContacts(this.organisation.id)
                this.fetchBillingSettings(this.organisation.id)
            })
        },
        initialize() {
            this.getXeroContacts()
            this.getAllAgreements()

        },
        getOrganisationAgreements(id) {
            Api().get('/admin/agreements/organisation/' + id).then(res => {
                this.organisationAgreements = res.data
                console.log(this.organisationAgreements)
                this.agreementKey++
            })
        },
        getOrganisationContacts(id) {
            Api().get('/admin/organisationContact/' + id).then(res => {
                this.contacts = res.data
            })
        },

        getAllAgreements() {
            Api().get('/admin/agreements').then(res => {
                this.allAgreements = res.data
            })
        },
        formatDate(date) {
            if (date == null) {
                return null
            } else {
                return dateformat(date, 'yyyy-mm-dd')
            }
        },
        async fetchBillingSummaries(id) {
            await Api().get('/admin/billingSummary/' + id).then(res => {
                this.billingSummary = res.data
            })
        },
        getGluePlans() {
            Api()
                .get("/admin/gluePlans")
                .then((response) => {
                    this.plans = response.data;
                });
        },
        fetchBillingSettings(id) {
            Api().get('/organisation/billingSettings/' + id).then(async res => {
                let billingSettings = res.data
                let billing = this.getBillingDates(billingSettings.billingDay, billingSettings.includeBillingDay)
                billingSettings.startDate = billing.startDate
                billingSettings.endDate = billing.endDate
                this.getIndicativeBilling(id, billing.startDate, billing.endDate)
            })
        },
        getIndicativeBilling(id, start, end) {
            Api().post('/admin/billingSummary/indicative/' + id, {
                billingStart: start,
                billingEnd: end
            }).then(res => {
                console.log(res.data)
                this.indicativeBilling = res.data
            })
        },
        getBillingDates(billingDay, includeBillingDay) {
            var today = new Date()
            let startDate = null
            let endDate = null
            switch (billingDay) {
                case '1st':
                    today.setMonth(today.getMonth())
                    today.setDate(1)
                    console.log(today)
                    var eom = new Date(today.getFullYear(), today.getMonth() + 1, 0)
                    console.log('From ' + today.getDate() + ' to ' + eom.getDate())
                    startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                    endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                    startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                    endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                    return {
                        startDate: startDate, endDate: endDate
                    }
                    case '7th':
                        if (includeBillingDay) {
                            today.setDate(8)
                        } else {
                            today.setDate(7)
                        }
                        today.setMonth(today.getMonth() - 2)
                        var eom = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 1)
                        eom.setDate(today.getDate() - 1)
                        startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                        endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                        return {
                            startDate: startDate, endDate: endDate
                        }
                        case '15th':
                            if (includeBillingDay) {
                                today.setDate(16)
                            } else {
                                today.setDate(15)
                            }
                            today.setMonth(today.getMonth() - 1)
                            var eom = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 1)
                            eom.setDate(today.getDate() - 1)
                            startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                            endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                            return {
                                startDate: startDate, endDate: endDate
                            }
                            case '25th':
                                if (includeBillingDay) {
                                    today.setDate(26)
                                } else {
                                    today.setDate(25)
                                }
                                today.setMonth(today.getMonth() - 1)
                                var eom = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 1)
                                eom.setDate(today.getDate() - 1)
                                startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                                endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                                return {
                                    startDate: startDate, endDate: endDate
                                }
            }
        },
        getXeroContacts() {
            Api().get('/xero/admin/contacts').then(res => {
                this.xeroContacts = res.data.body.contacts.map(x => ({
                    id: x.contactID,
                    name: x.name
                }))
            })
        },
        getOrganisationSubscriptions(id) {
            Api().get('/admin/subscription/' + id).then(res => {
                this.subscriptions = res.data
            })
        },
        getXeroInvoices(xeroContactId) {
            Api().get('/xero/admin/invoices/' + xeroContactId).then(res => {
                console.log(res.data)
                this.xeroInvoices = res.data.body.invoices.map(x => ({
                    invoiceNumber: x.invoiceNumber,
                    date: x.date,
                    dueDate: x.dueDate,
                    status: x.status,
                    subtotal: x.subTotal,
                    total: x.total,
                    totalTax: x.totalTax,
                    amountPaid: x.amountPaid,
                    amountDue: x.amountDue
                }))
            })
        },
        getStatusColor(status) {
            switch (status) {
                case 'PAID':
                    return 'green'
                case 'VOIDED':
                    return 'red'
                case 'DELETED':
                    return 'red'
                default:
                    return 'blue'
            }
        },
        updateOrganisation(item) {
            Api().put('/admin/organisation/' + item.id, item)
        },
        createSubscription() {
            Api().post('/admin/createSubscription', this.item).then(res => {
                this.getOrganisationSubscriptions(this.organisation.id)
                this.subscriptionModal = false
                this.item = {}
            })
        },
        updateSubscription() {
            Api().put('/admin/updateSubscription/' + this.item.id, this.item).then(res => {
                this.getOrganisationSubscriptions(this.organisation.id)
                this.subscriptionModal = false
                this.item = {}
            })
        },
        deleteSubscription(item) {
            Api().put('/admin/updateSubscription/' + item.id, {
                isActive: false,
                isDeleted: true
            }).then(res => {
                this.getOrganisationSubscriptions(this.organisation.id)
                this.subscriptionModal = false
                this.item = {}
            })
        },
        updateVariables() {
            if (this.item.agreement) {
                var content = this.item.agreement.content
                let variables = []
                if (content) {
                    let split = content.replace(/\n/g, ' ').split(' ')
                    variables = split.filter(x => x.includes('{{') && x.includes('}}'))
                    variables = [...new Set(variables.map(x=>x.replace('{{', '').replace('}}', '')))]
                    variables = variables.map(x => ({
                        key: x,
                        value: null
                    }))
                }
                this.item.variables = variables
                this.variableKey++
            } else {
                this.item.variables = []
            }
        },
        downloadContent(item) {
            Api().get('/admin/agreements/' + item.id).then(response => {
                let file = Buffer.from(response.data, "base64");
                const linkSource = `data:application/pdf;base64,${response.data}`;
                const downloadLink = document.createElement("a");
                const fileName = item.name + '.pdf'

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
        },
        submitAgreement() {
            let obj = {
                name: this.item.name,
                organisationId: this.organisation.id,
                content: this.formattedContent,
                assignedToId: this.item.contactId,
                date: this.item.date
            }
            Api().post('/admin/agreements/organisation', obj).then(res => {
                this.documentModal = false
                this.item = {}
                this.page = 0
                this.getOrganisationAgreements(this.organisation.id)
            })
        }
    }

}
</script>
